import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";

const GROUP_KEYS = ["g1", "g2", "g3"];
const CARD_KEYS = ["c1", "c2"];

const SchedulePageSkeleton = () => (
	<Container maxWidth="lg" sx={{ pt: 2 }}>
		<Paper sx={{ p: 2, mb: 2 }}>
			<Stack
				direction="row"
				sx={{
					justifyContent: "space-between",
					alignItems: "center",
				}}
			>
				<Stack
					direction="row"
					spacing={1}
					sx={{
						alignItems: "center",
					}}
				>
					<Skeleton variant="text" width={120} height={32} />
					<Skeleton variant="circular" width={28} height={28} />
				</Stack>
				<Skeleton
					variant="rectangular"
					width={100}
					height={36}
					sx={{ borderRadius: 1 }}
				/>
			</Stack>
		</Paper>
		<Skeleton
			variant="rectangular"
			width={240}
			height={36}
			sx={{ mb: 2, borderRadius: 1 }}
		/>
		<Stack spacing={3}>
			{GROUP_KEYS.map((gKey) => (
				<Box key={gKey}>
					<Stack
						direction="row"
						spacing={1}
						sx={{
							alignItems: "center",
							mb: 1,
						}}
					>
						<Skeleton variant="text" width={180} height={28} />
						<Skeleton variant="circular" width={24} height={24} />
					</Stack>
					<Grid container spacing={2}>
						{CARD_KEYS.map((cKey) => (
							<Grid size={{ xs: 12, sm: 6 }} key={`${gKey}-${cKey}`}>
								<Paper sx={{ p: 2 }}>
									<Skeleton variant="text" width={160} height={20} />
									<Skeleton variant="text" width={120} height={20} />
									<Skeleton
										variant="text"
										width={200}
										height={16}
										sx={{ mt: 1 }}
									/>
								</Paper>
							</Grid>
						))}
					</Grid>
				</Box>
			))}
		</Stack>
	</Container>
);

export default SchedulePageSkeleton;
